import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { Seibi } from '@/models/Seibi';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class SeibiService {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getSeibi(title: string = "", version: any = "",
        sknInspectSeibiFeeId: any = null
        // 2022-01-31 morisako kobac-free mod [START]
        , isFree: boolean = false) {
        // 2022-01-31 morisako kobac-free mod [END]
        let path = `${this.baseAPI}/seibi/kousuu`;
        let arrParam = [];
        let q = "";
        if (version) {
            path += "/" + version;
        }
        if (title) {
            // path += "?title=" + title;
            arrParam.push("title=" + title);
        }
        if (sknInspectSeibiFeeId) {
            arrParam.push("sknInspectSeibiFeeId=" + sknInspectSeibiFeeId);
        }
        // 2022-01-31 morisako kobac-free add [START]
        if (isFree) {
            arrParam.push("isFree=true");
        } else {
            arrParam.push("isFree=false");
        }
        // 2022-01-31 morisako kobac-free add [END]
        if (arrParam.length > 0) {
            q = "?" + arrParam.join("&");
        }
        const { result, error } = await this.commonService.get(path + q);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getSeibi');
            return;
        }
    }

    public async editSeibi(data: Seibi) {
        let path = `${this.baseAPI}/seibi/kousuu`;
        const { result, error } = await this.commonService.put(path, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editSeibi');
            return;
        }
    }

    public async saveSeibi(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/seibi-order-display`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async deleteSeibi(id: number, sknInspectSeibiFeeId: number) {
        let q = "";
        if (sknInspectSeibiFeeId) {
            q = `?sknInspectSeibiFeeId=${sknInspectSeibiFeeId}`;
        }
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/seibi/${id}${q}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteSeibi');
            return;
        }
    }

    // ============================

    public async getMExpSeibiShuukeiKbn() {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/seibi/shuukei-kbn`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getMExpSeibiShuukeiKbn');
            return;
        }
    }
    public async getMExpSeibiWorkGroup() {
        const { result, error } = await this.commonService.get(`${this.baseAPI}/seibi/work-group`);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getMExpSeibiWorkGroup');
            return;
        }
    }
    public async getExpSeibi(searchVO: any, form: any, sknInspectSeibiTitle: string) {
        let path = `${this.baseAPI}/seibi/exp-seibi-kousuu`;
        let arrParam = [];
        let arrQParam = [];
        let q = "";
        if (searchVO.page) {
            arrParam.push("page=" + searchVO.page);
        }
        if (searchVO.size) {
            arrParam.push("size=" + searchVO.size);
        }
        if (arrParam.length > 0) {
            q = "?" + arrParam.join("&");
        }
        if (form.groupCd) {
            arrQParam.push("group_cd=" + form.groupCd);
        }
        if (form.shatenCd) {
            arrQParam.push("shaten_cd=" + form.shatenCd);
        }
        if (form.kyotenCd) {
            arrQParam.push("kyoten_cd=" + form.kyotenCd);
        }
        if (form.version) {
            arrQParam.push("version_id=" + form.version);
        }
        if (form.sknInspectSeibiFeeId) {
            arrQParam.push("skn_inspect_seibi_fee_id=" + form.sknInspectSeibiFeeId);
        }
        if (sknInspectSeibiTitle) {
            arrQParam.push("skn_inspect_seibi_title=" + sknInspectSeibiTitle);
        }
        // 2022-01-31 morisako kobac-free add [START]
        if (form.isFree) {
            arrQParam.push("is_free=true");
        } else {
            arrQParam.push("is_free=false");
        }
        // 2022-01-31 morisako kobac-free add [END]
        if (q.length == 0) {
            q = '?';
        } else {
            q += '&';
        }
        if (arrQParam.length > 0) {
            q += 'q=' + arrQParam.join(",");
        }
        const { result, error } = await this.commonService.get(path + q);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getExpSeibi');
            return;
        }
    }
    public async saveMSknExpSeibiDetail(data: any) {
      const { result, error } = await this.commonService.post(`${this.baseAPI}/seibi/exp-seibi-kousuu`, data);
      if (result) {
        return result.status;
      } else {
        this.authService.handleError(error, 'saveMSknExpSeibiDetail');
        return;
      }
    }
    /** 2022-09-15 sh #7846(BQR965) implements the function for exp seibi. [START] */
//    public async deleteExpSeibi(id: number) {
//        const { result, error } = await this.commonService.delete(`${this.baseAPI}/seibi/exp-seibi/${id}`);
//        if (result) {
//            return result.status;
//        } else {
//            this.authService.handleError(error, 'deleteExpSeibi');
//            return;
//        }
//    }
    public async deleteExpSeibi(id: number, data?: any) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/seibi/exp-seibi/${id}`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteExpSeibi');
            return;
        }
    }
    /** 2022-09-15 sh #7846(BQR965) implements the function for exp seibi. [END] */
    public async getExpSeibiBuhin(param: any) {
        let path = `${this.baseAPI}/seibi/exp-seibi-buhin`;
        let arrParam = [];
        let q = "";
        if (param.groupCd) {
            arrParam.push("group_cd=" + param.groupCd);
        }
        if (param.shatenCd) {
            arrParam.push("shaten_cd=" + param.shatenCd);
        }
        if (param.workCd) {
            arrParam.push("work_cd=" + param.workCd);
        }
        // 2022-01-31 morisako kobac-free add [START]
        if (param.sknInspectSeibiFeeId) {
            arrParam.push("skn_inspect_seibi_fee_id=" + param.sknInspectSeibiFeeId);
        }
        // 2022-01-31 morisako kobac-free add [END]
        if (arrParam.length > 0) {
            q = "?q=" + arrParam.join(",");
        }
        const { result, error } = await this.commonService.get(path + q);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getExpSeibiBuhin');
            return;
        }
    }
    public async saveExpSeibiBuhin(data: any[]) {
      const { result, error } = await this.commonService.post(`${this.baseAPI}/seibi/exp-seibi-buhin`, data);
      if (result) {
        return result.status;
      } else {
        this.authService.handleError(error, 'saveExpSeibiBuhin');
        return;
      }
    }

    public async getOsusumeInspectSeibi(searchVO: any, form: any, sknInspectSeibiTitle: string) {
        let path = `${this.baseAPI}/admin/osusume_inspect_seibi`;
        let arrParam = [];
        let arrQParam = [];
        let q = "";
        if (searchVO.page) {
            arrParam.push("page=" + searchVO.page);
        }
        if (searchVO.size) {
            arrParam.push("size=" + searchVO.size);
        }
        if (arrParam.length > 0) {
            q = "?" + arrParam.join("&");
        }
        if (form.groupCd) {
            arrQParam.push("group_cd=" + form.groupCd);
        }
        if (form.shatenCd) {
            arrQParam.push("shaten_cd=" + form.shatenCd);
        }
        if (form.kyotenCd) {
            arrQParam.push("kyoten_cd=" + form.kyotenCd);
        }
        if (form.version) {
            arrQParam.push("version_id=" + form.version);
        }
        if (form.sknInspectSeibiFeeId) {
            arrQParam.push("skn_inspect_seibi_fee_id=" + form.sknInspectSeibiFeeId);
        }
        if (sknInspectSeibiTitle) {
            arrQParam.push("skn_inspect_seibi_title=" + sknInspectSeibiTitle);
        }
        if (q.length == 0) {
            q = '?';
        } else {
            q += '&';
        }
        if (arrQParam.length > 0) {
            q += 'q=' + arrQParam.join(",");
        }
        const { result, error } = await this.commonService.get(path + q);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getOsusumeInspectSeibi');
            return;
        }
    }

    public async updateOsusumeImportKbn(data: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/osusume/import-kbn`, data);
        if (result) {
          return result.status;
        } else {
          this.authService.handleError(error, 'updateOsusumeImportKbn');
          return;
        }
      }

    public async saveOsusumeMSknExpSeibiDetail(data: any) {
    const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/osusume/exp-seibi`, data);
    if (result) {
        return result;
    } else {
        this.authService.handleError(error, 'saveOsusumeMSknExpSeibiDetail');
        return;
    }
    }

    // 2022-01-31 morisako kobac-free add [START]
    public async saveMSknInspectSeibiFeeExtension(data: any) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/admin/osusume/fee_extension`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'saveMSknInspectSeibiFeeExtension');
            return;
        }
    }
    // 2022-01-31 morisako kobac-free add [END]
}
